import { useRef } from "react";
import { motion, useInView } from "framer-motion";
import { Download, Eye } from "lucide-react";
import { personalInfo } from "../data/portfolio";

export default function Resume() {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-80px" });

  return (
    <section id="resume" className="relative px-6 md:px-16 lg:px-24 py-24">
      <div className="max-w-6xl mx-auto">
        <motion.div
          ref={ref}
          initial={{ opacity: 0, y: 30 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.8, ease: [0.23, 1, 0.32, 1] }}
          className="glass-card relative overflow-hidden p-10 md:p-16 flex flex-col md:flex-row items-center justify-between gap-8"
        >
          {/* BG decoration */}
          <div className="absolute -right-24 -top-24 w-64 h-64 rounded-full opacity-10 blur-3xl pointer-events-none"
               style={{ background: "radial-gradient(circle, #60a5fa, #a78bfa)" }} />

          <div>
            <p className="font-mono text-xs tracking-[0.2em] uppercase text-blue-400 mb-3">
              06 // Resume
            </p>
            <h2 className="font-display font-black text-3xl md:text-4xl tracking-tight text-white mb-3">
              Want the full picture?
            </h2>
            <p className="text-white/45 text-base max-w-md leading-relaxed">
              My resume covers experience, projects, education, and more — all in one place.
              Drop me a message if you'd like to connect.
            </p>
          </div>

          <div className="flex flex-col sm:flex-row gap-3 shrink-0">
            <a
              href={personalInfo.resumeUrl}
              target="_blank"
              rel="noreferrer"
              data-hover
              className="flex items-center gap-2 px-6 py-3.5 rounded-lg text-sm font-semibold text-white/60 border border-white/10 hover:text-white hover:border-white/20 hover:bg-white/[0.04] transition-all duration-300 hover:-translate-y-1"
            >
              <Eye size={15} />
              View Resume
            </a>
            <a
              href={personalInfo.resumeUrl}
              download
              data-hover
              className="flex items-center gap-2 px-6 py-3.5 rounded-lg text-sm font-semibold text-white transition-all duration-300 hover:-translate-y-1 hover:shadow-[0_12px_40px_rgba(96,165,250,0.3)]"
              style={{ background: "linear-gradient(135deg, #60a5fa, #a78bfa)" }}
            >
              <Download size={15} />
              Download PDF
            </a>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
